import { useSearchParams } from 'react-router-dom';
import { ScoringWidget } from '@/components/scoring/ScoringWidget';

export default function TryPage() {
  const [params] = useSearchParams();

  const isEmbedded = params.get('embedded') === 'true';
  const vertical = params.get('vertical') || 'auto_insurance';
  const source = params.get('source') || 'direct';
  // Support ?chatbot=UUID to preview a specific engine
  const chatbotId = params.get('chatbot') || '11111111-1111-4111-8111-111111111111';

  // Brand params (passed from embed.js via URL params)
  const brandName = params.get('brand_name') || undefined;
  const brandColor = params.get('brand_color') || undefined;
  const brandLogo = params.get('brand_logo') || undefined;
  const brandTagline = params.get('brand_tagline') || undefined;

  const brandProps = {
    ...(brandName ? { brandName } : {}),
    ...(brandColor ? { brandColor } : {}),
    ...(brandLogo ? { brandLogo } : {}),
    ...(brandTagline ? { brandTagline } : {}),
  };

  // When loaded inside the affiliate embed iframe, render the widget
  // full-width with no outer chrome so it fills the iframe viewport.
  if (isEmbedded) {
    return (
      <div className="h-screen w-full bg-slate-950 flex items-center justify-center">
        <ScoringWidget
          chatbotId={chatbotId}
          entryIntent={{ primary_vertical: vertical, source, confidence: 0.5 }}
          embedded={true}
          {...brandProps}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <ScoringWidget
        chatbotId={chatbotId}
        entryIntent={{ primary_vertical: 'auto_insurance', source: 'direct', confidence: 0.5 }}
        embedded={true}
        {...brandProps}
      />
    </div>
  );
}
